import {ElementType, forwardRef, PropsWithChildren, useState} from 'react';
import {useElementSize, useViewportSize} from '@mantine/hooks';
import {UnnormalizedProps as UnnormalizedStyleProps} from '@yosmanyga/core-style';
import {useVariables} from "@yosmanyga/theme";
import {Button, Container, Icon, Modal, Progress, useIcons} from '@yosmanyga/rich-ui';
import background from "./assets/images/background.png";

const BlankLayout = forwardRef(({
    templates,
    progress,
    onBack,
    children,
}: PropsWithChildren<{
    templates?: {
        help?: ElementType,
        footer?: ElementType
    },
    progress?: boolean,
    onBack?: () => void,
} & UnnormalizedStyleProps>, ref) => {
    // Need to use spacing to add to heights because ResizeObserver doesn't take padding into account
    const {spacing} = useVariables();

    const {ref: headerRef, height: headerHeight} = useElementSize();
    const {ref: footerRef, height: footerHeight} = useElementSize();

    const {height} = useViewportSize();

    const [modal, setModal] = useState(false);

    const icons = useIcons();

    return <Container
        align={{
            main: 'flex-end'
        }}
        box="border-box" // TODO
        width="100%" // TODO
        background={`${background} repeat, #fff`}
        // opacity={0.05}
        padding={1}
    >
        {onBack && !progress && <Container
            ref={headerRef}
            flow='row'
            align={{
                main: 'space-between'
            }}
        >
            <Button
                onClick={onBack}
            >
                <Icon
                    component={icons.actions.back}
                    size='xs'
                />
            </Button>

            {templates?.help && <Container>
                <Button
                    onClick={() => {
                        setModal(true)
                    }}
                >
                    <Icon
                        component={icons.objects.help}
                        size='xs'
                    />
                </Button>
            </Container>}
        </Container>}

        {progress
            ? <Progress/>
            : <>
                <Container
                    ref={ref}
                    scroll
                    height={
                        height - spacing(2)
                        - headerHeight // Header row
                        - spacing(1)
                        - (templates?.footer ? footerHeight : 0) - spacing(1) // Footer row
                    }
                    padding={{
                        top: 1
                    }}
                >
                    {children}
                </Container>

                {templates?.footer && <Container
                    ref={footerRef}
                    padding={{
                        top: 1,
                    }}
                >
                    <templates.footer/>
                </Container>}
            </>
        }

        {templates?.help && modal && <Modal
            onClose={() => {
                setModal(false);
            }}
        >
            <Container intent="modal_body">
                <templates.help/>
            </Container>
        </Modal>}
    </Container>
});

export {
    BlankLayout
};
